import GoogleAnalyticsEventBase from './GoogleAnalyticsEventsBase';

class GoogleAnalyticsEvent extends GoogleAnalyticsEventBase {
    public searchImpression(): void {
        this.trackEvent('search_impression');
    }

    public trackBookingIntention(data: GoogleAnalytics4BookingIntentionEvent): void {
        this.trackEvent<GoogleAnalytics4BookingIntentionEvent>('checkout_booking_intention', data);
    }

    public viewPromotion(data: GoogleAnalytics4PromotionEvent): void {
        this.trackEvent<GoogleAnalytics4PromotionEvent>('view_promotion', data);
    }

    public selectPromotion(data: GoogleAnalytics4PromotionEvent): void {
        this.trackEvent<GoogleAnalytics4PromotionEvent>('select_promotion', data);
    }

    public trackCheckoutMobileDetailsModal(): void {
        this.trackEvent('open_checkout_mobile_details');
    }

    public updateConsentMode(data: GoogleAnalytics4ConsentModeEvent): void {
        this.trackConsent('update', data);
    }
}

export { GoogleAnalyticsEvent };
export default new GoogleAnalyticsEvent();
